/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../layout.ts"/>
/// <reference path="../../../navigation/side_nav/side_nav_left.ts"/>
/// <reference path="../../../page/page.ts"/>

namespace Dealerware {
    export namespace Layout {

        "use strict";

        import IDealerwareSideNavLeftDelegate = Dealerware.Navigation.IDealerwareSideNavLeftDelegate;
        import IDealerwarePageDelegate = Dealerware.Page.DealerwarePageDelegate;

        export interface IDealerwareApplicationLayoutDelegate extends IDealerwareLayoutDelegate {

            // properites
            // ----------------------------------------
            leftNavigationDelegate : IDealerwareSideNavLeftDelegate;

            // methods
            // ----------------------------------------


        }

        export interface IDealerwareApplicationLayoutController extends IDealerwareLayoutController {

            // properties
            // ---------------------------------------------
            pageDelegate : IDealerwarePageDelegate;

            // methods
            // -----------------------------------------------

        }


        export class DealerwareApplicationLayoutDelegate extends DealerwareLayoutDelegate implements IDealerwareApplicationLayoutDelegate {

            // properties
            // --------------------------------------------
            private _pageTitle : string;
            public static $inject: string[] = ['$state','$mobilityCurrentStateDelegate','$mdSidenav','$mdMedia','$timeout','$dealerwareSideNavLeftDelegate'];

            // constructor
            // --------------------------------------------
            constructor(public $state : any, public $mobilityCurrentStateDelegate : any, public $mdSidenav : any, public $mdMedia : any,public $timeout : any,public leftNavigationDelegate : IDealerwareSideNavLeftDelegate) {
                super($state,$mobilityCurrentStateDelegate);
                this.configSectionKey   =   'applicationLayout';
            }

            // Accessors
            // -------------------------------------------

            // methods
            // --------------------------------------------

        }

        export class DealerwareApplicationLayoutController extends DealerwareLayoutController implements IDealerwareApplicationLayoutController {

            // properties
            // ----------------------------------------------
            public static $inject   :   string[] = [
                '$dealerwareApplicationLayoutDelegate',
                '$rootScope',
                '$scope',
                '$timeout',
                'CurrentUser',
                'AppConfig',
                '$dealerwarePageDelegate'
            ];

            // constructor
            // ----------------------------------------------
            constructor(public layoutService: IDealerwareApplicationLayoutDelegate,
                        public $rootScope: any,
                        public $scope: any,
                        public $timeout: any,
                        public CurrentUser: any,
                        public appConfig: any,
                        public pageDelegate : IDealerwarePageDelegate) {
                super(layoutService,$rootScope,$scope,$timeout);
            }

            // methods
            // ----------------------------------------------

            public registerEvents() : void {

                var _self = this;

                super.registerEvents();

                // stateChangeSuccess
                this.registeredEvents.push(
                    this.$rootScope.$on('$stateChangeSuccess',function() {
                        _self.handleStateChangeSuccess();
                    })
                );

                this.registeredEvents.push(
                    this.$rootScope.$on('$stateChangeStart',function(event : any,toState : any,toParams : any,fromState : any,fromParams : any) {
                        _self.handleStateChangeStart(event,toState,toParams,fromState,fromParams);
                    })
                );

            }

            public handleStateChangeSuccess() : void {
                this.layoutService.getLayoutClass();
            }

            public handleStateChangeStart(event : any,toState : any,toParams : any,fromState : any,fromParams : any) : void {
                if (toState != fromState) {

                    // this.pageDelegate.pageTitle = null;
                }
            }



        }

        getDealerwareLayoutModule().service('$dealerwareApplicationLayoutDelegate',DealerwareApplicationLayoutDelegate);
        getDealerwareLayoutModule().controller('$dealerwareApplicationLayoutController',DealerwareApplicationLayoutController);

    }
}